// SERVICES



// STATE
import PassportTypeService from "@/services/passport-type.service";

const state =  {
    list:[],
    total:0
};

// GETTERS
const getters = {

}

// ACTIONS
const actions = {
    async getList({commit}, params) {
        try {
            const res = await PassportTypeService.getList(params)
            await commit('setListResponse', res);
        } catch (error) {
            await commit('setListResponse', error.response.data);
        }
    }
}

// MUTATIONS
const mutations = {
    setListResponse(state, payload) {
        state.list = payload.data.list
        state.total = payload.data.total
    }
}

export const passportType = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
